<template>
  <div v-if="playback" class="video-preview">
    <iframe
      v-if="playback.mode === 'iframe'"
      :src="playback.src"
      class="video-frame"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      allowfullscreen
      referrerpolicy="no-referrer-when-downgrade"
      title="پیش‌نمایش ویدیو"
    />
    <video
      v-else
      :src="playback.src"
      controls
      playsinline
      class="video-frame"
    />
    <a
      v-if="url"
      :href="url"
      target="_blank"
      rel="noopener noreferrer"
      class="video-link"
    >{{ url }}</a>
  </div>
  <span v-else class="empty">—</span>
</template>

<script>
import { resolveVideoPlayback } from '../utils/videoEmbed'

export default {
  name: 'ApprovalVideoPreview',

  props: {
    url: { type: String, default: null },
  },

  computed: {
    playback() {
      return resolveVideoPlayback(this.url)
    },
  },
}
</script>

<style scoped>
.video-preview {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.video-frame {
  width: 100%;
  max-width: 360px;
  aspect-ratio: 16 / 9;
  border: 0;
  border-radius: 8px;
  background: #000;
}

.video-link {
  font-size: 11px;
  color: rgba(var(--colors-primary-600), 1);
  word-break: break-all;
  text-decoration: underline;
}

.empty {
  color: rgba(var(--colors-gray-400), 1);
}

html.dark .video-link,
.dark .video-link {
  color: rgba(var(--colors-primary-300), 1);
}
</style>
